var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterConfirmCountry.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxListItem, LoadingModal } from '@adc/parallax-component-library';
import { ApiStatus } from 'Constants';
import { useApiError } from 'Hooks';
import { CountryBottomSheetModal, Footer, Form, Header, LogoActionBar, Main, RichText, ScrollContainer, SelectorInput } from 'Components/utility';
import { REGISTER, REGISTER_CLEAR } from 'Reducers/register/types';
import { setUrls } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
const mapStateToProps = ({
  config,
  env
}) => {
  return {
    env,
    config
  };
};
const connector = connect(mapStateToProps);
const RegisterConfirmCountry = ({
  next,
  back,
  values,
  env,
  config
}) => {
  const [isBottomSheetModalOpen, setIsBottomSheetModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const onSubmit = useCallback(() => {
    const {
      language
    } = store.getState().lang;
    const register = {
      ...values,
      language,
      countryResidenceChecked: false
    };
    const config = store.getState().config;
    setUrls(config, register.country);
    next(register);
  }, [next, values]);
  const onCancelBottomSheetModal = useCallback(() => {
    setIsBottomSheetModalOpen(false);
  }, []);
  const onCountryOfResidenceChecked = useCallback(() => {
    store.dispatch({
      type: REGISTER,
      register: {
        ...values,
        countryResidenceChecked: !values.countryResidenceChecked,
        currentStep: 0
      }
    });
  }, [values]);
  const handleWrongRegionError = useCallback((error, handleSubmit) => {
    const unsupportedCountry = error.response?.data.errors[0]?.unsupportedCountry;
    if (!unsupportedCountry) {
      showApiErrorModal();
      return;
    }
    setUrls(config, unsupportedCountry);
    handleSubmit();
  }, [config, showApiErrorModal]);
  const onSelectCountry = useCallback(async selectedCountry => {
    try {
      setIsBottomSheetModalOpen(false);
      setLoading(true);
      const {
        app,
        pId,
        redirect_uri,
        cid
      } = env;
      await updateConfig(selectedCountry, app, pId, redirect_uri, cid);
      setLoading(false);
      store.dispatch({
        type: REGISTER,
        register: {
          ...values,
          currentStep: 0,
          country: selectedCountry,
          ...(selectedCountry !== 'FR' && {
            gender: '',
            birthCountry: '',
            birthZipCode: ''
          })
        }
      });
    } catch (err) {
      const error = err;
      setLoading(false);
      if (error.status === ApiStatus.BAD_REQUEST) {
        const code = error.response?.data.code;
        if (code === ApiStatus.WRONG_REGION) {
          handleWrongRegionError(error, () => onSelectCountry(selectedCountry));
          return;
        }
      }
      showApiErrorModal();
    }
  }, [env, handleWrongRegionError, showApiErrorModal, values]);
  const handleOnBack = useCallback(() => {
    store.dispatch({
      type: REGISTER_CLEAR
    });
    back();
  }, [back]);
  const selectorValue = useMemo(() => {
    return values.country ? i18n.t(`Global.microcopy.countries.${values.country.toUpperCase()}`) : '';
  }, [values.country]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 5
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "ConfirmCountry.action-go-back",
    titleTestID: "ConfirmCountry.actionTitle",
    title: i18n.t('ConfirmCountry.title'),
    onBack: handleOnBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "ConfirmCountry.title",
    subtitleTestID: "ConfirmCountry.subtitle",
    title: i18n.t('ConfirmCountry.title'),
    subtitle: i18n.t('ConfirmCountry.subtitle'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SelectorInput, {
    testID: "ConfirmCountry",
    label: i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    placeholder: i18n.t('ConfirmCountry.content.selectCountry.secondaryText'),
    "aria-label": i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    value: selectorValue,
    onClick: () => setIsBottomSheetModalOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(CheckboxListItem, {
    checked: values.countryResidenceChecked,
    onPress: onCountryOfResidenceChecked,
    testID: "ConfirmCountry.checkBox"
    // @ts-expect-error all good.
    ,
    title: /*#__PURE__*/React.createElement(RichText, {
      text: i18n.t('ConfirmCountry.content.selectCountry.bodyText'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 15
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('Global.microcopy.common.next'),
    onButtonSubmit: onSubmit,
    buttonTestID: "ConfirmCountry.next-btn",
    isButtonDisabled: !values.countryResidenceChecked || !values.country,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(CountryBottomSheetModal, {
    isOpen: isBottomSheetModalOpen,
    onCancel: onCancelBottomSheetModal,
    onDone: onSelectCountry,
    selectedCountry: values.country,
    title: i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    countries: config.supportedCountries,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 7
    }
  }));
};
export default connector(RegisterConfirmCountry);